import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { IRule } from '@/classes/rules/IRule';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { Invalidation } from '@/classes/rules/Invalidation';
import { FieldUsage } from '@/classes/rules/FieldUsage';

const noDefaultValue = () => null;
const available = () => true;

/**
 * IRule to handle boolean values
 */
export class BooleanRule<Context = ScenarioExt> implements IRule<Context> {
  public key: string;
  public required: boolean;
  public displayed: boolean = true;
  public fieldUsage: FieldUsage;
  public isAvailable: (context: Context) => boolean;
  public getDefaultValue: (context?: Context) => DefaultValue<boolean> | null;

  public constructor(
    key: string,
    isAvailable?: (context: Context) => boolean,
    getDefaultValue?: (context?: Context) => DefaultValue<boolean> | null,
    required?: boolean
  ) {
    this.key = key;
    this.isAvailable = isAvailable ?? available;
    this.getDefaultValue = getDefaultValue ?? noDefaultValue;
    this.required = required ?? true;
    this.fieldUsage = new FieldUsage();
  }

  public get invalidation(): Invalidation {
    return this.fieldUsage.getInvalidation();
  }

  public checkValue(val: boolean | null, context: Context): boolean | null {
    if (val === null) {
      return null;
    }
    return val === true || val === false;
  }

  public withIsAvailable(isAvailable: (context: Context) => boolean): this {
    this.isAvailable = isAvailable;
    return this;
  }

  public withDefaultValue(getDefaultValue: (context?: Context) => DefaultValue<boolean> | null): this {
    this.getDefaultValue = getDefaultValue;
    return this;
  }

  public withRequired(isRequired?: boolean): this { // true is default setting for this function
    this.required = isRequired !== false;
    return this;
  }

  public withFieldUsage(fieldUsage: FieldUsage): this {
    this.fieldUsage = fieldUsage;
    return this;
  }
}
